<template>
  <v-app>
    <v-main class="page">
      <v-container class="height-100" fluid>
        <transition>
          <router-view ref="PageView"></router-view>
        </transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>
